
class cartUtils {
  /**
   * Add a single variant to cart with properties
   * @param {number|string} variantId
   * @param {Object} properties
   */

  static openAndRefreshCart(){
    // const cartDrawer = document.querySelector('cart-drawer');
    // cartDrawer.openCartDrawerOnProductAdded()
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
  }

  static async getCart(){
    let currentCart = await fetch('/cart.js').then(response => response.json())
  }

  static addVariant(variantId, properties = {}, quantity = 1,shouldLimit) {
    if (!variantId) {
      console.error('productUtils.addVariant: missing variantId');
      return;
    }

    if(shouldLimit){
      let cart = getCart()
      let currentItemAmount = cart.items.filter(item => item.id == '52614861357393')[0].quantity

      if(currentItemAmount == shouldLimit) {
        return
      }
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(data => {
        this.openAndRefreshCart()
        return data;
      })
      .catch(err => {
        console.error('productUtils.addVariant error:', err);
      });
  }

  /**
   * Credits
   */
  static CREDITS() {
    const Credits = {
      Developers : "Mateo Sierra Betancur",
      Designers : "Paula Farre",
      Management : "Gonzalo arechavala",
      Agency : "rockin. media",
    }

    return Credits
  }
}
